import http from '@/util/http';

export default {
	permissionValidation() {
		return http.get('BillRequest/api/permissionValidation');
	},
	getBillRequestMonths(billType) {
		return http.get('BillRequest/api/getBillRequestMonths', { params: { billType } });
	},
	applyBillRequest(payload) {
		return http.post('BillRequest/api/applyBillRequest', payload)
	},
	confirm(code) {
		return http.get('BillRequest/api/confirm', { params: { code } })
	},
}


// WEBPACK FOOTER //
// ./src/api/billRequest/billRequestApi.js